import { DAM_API_URL, API_URI } from 'Constant';
export const UploadAssetsURL = `${DAM_API_URL}/apidam/uploadFile`;
export const shareAssetsURL = `${DAM_API_URL}/apidam/shareasstes`;
export const AddAssetInformationURL = `${DAM_API_URL}/apidam/savefromdraft`;
export const GETAllActiveSKUCodes = `${API_URI}/api/clients/products/getallactivesku`;
export const GET_ALL_USERS_BY_CLIENT = `${API_URI}/api/clients/users/getusersbyclient`;
export const GETListOfCountriesURL = `${DAM_API_URL}/apidam/listofcountry`;
export const GETListOfDAMCategoriesURL = `${DAM_API_URL}/apidam/listofcategory`;
export const GETListOfTagsURL = `${DAM_API_URL}/apidam/tagslist`;
export const addAssetInformationURL = `${DAM_API_URL}/apidam/savefromdraft`;
export const GETListofDraftTransactionsURL = `${DAM_API_URL}/apidam/gettarnsactionassets`;
export const GETDraftTransByGroupIdURL = `${DAM_API_URL}/apidam/gettransactionbygroupid`;
export const GETListofDraftAssetsURL = `${DAM_API_URL}/apidam/getdraftassets`;
export const MoveToDraftAssetsURL = `${DAM_API_URL}/apidam/drafttoassets`;
export const DeleteDraftTransURL = `${DAM_API_URL}/apidam/delete-asset-forever`;
export const DeleteDraftAssetURL = `${DAM_API_URL}/apidam/delete-asset-forever`;
// export const ListofDeactivatedAssetsURL = `${DAM_API_URL}/apidam/listofdeactiveasset`;
export const ChangeAssetsStatusURL = `${DAM_API_URL}/apidam/changeassetstatus`;
export const ListofActiveAssetsURL = `${DAM_API_URL}/apidam/listofactiveassets`;
export const ListofAllAssetsURL = `${DAM_API_URL}/apidam/listAssets`;
export const EditAssetDetailsURL = `${DAM_API_URL}/apidam/editsingleassets`;
export const DOWNLOAD_ASSET_URL = `${DAM_API_URL}/apidam/download-file-by-url`;
export const DownloadAssetURL = `${DAM_API_URL}/apidam/download?fileName=`;
export const ListofCollectionsURL = `${DAM_API_URL}/apidam/listofcollection`; //|
export const createCollectionURL = `${DAM_API_URL}/apidam/createcollection`;
export const deleteCollectionURL = `${DAM_API_URL}/apidam/deletecollection`;
export const shareCollectionURL = `${DAM_API_URL}/apidam/sharecollection`;
export const sharedWithMeCollectionsURL = `${DAM_API_URL}/apidam/sharedwithme`;
export const getSingleCollectionURL = `${DAM_API_URL}/apidam/getsinglecollection/`;
export const renameCollectionURL = `${DAM_API_URL}/apidam/renamecollection`;
export const downloadCollectionURL = `${DAM_API_URL}/apidam/downloadcollectionaszip`;
export const GetAssetInfoURL = `${DAM_API_URL}/apidam/getsingleasset/`;
export const UpdateAssetInfoURL = `${DAM_API_URL}/apidam/savefromdraft`;
export const searchTermURL = `${DAM_API_URL}/apidam/searchasstes`;
export const categoriesListURL = `${DAM_API_URL}/apidam/listofcategory`;
export const getSelectedCategoryDataURL = `${DAM_API_URL}/apidam/getselectedcategorydata`;
export const getRecentlyAddedAssetsURL = `${DAM_API_URL}/apidam/getrecentlyadded`;
export const generateOtpURL = `${DAM_API_URL}/security/generateOtp`;
export const validateOtpURL = `${DAM_API_URL}/security/validateOtp`;
export const saveToDraftURL = `${DAM_API_URL}/apidam/movetodraft`;
export const getPopularSKUsURL = `${DAM_API_URL}/apidam/gettopsku`;
export const sharedAssetsURL = `${DAM_API_URL}/apidam/getsharedassets`;
// export const downloadCollectionByIdURL = `${DAM_API_URL}/apidam/downloadcollectionbyid/`;
export const revokeSharedAssetURL = `${DAM_API_URL}/apidam/revokeshareassets`;
export const sharedCollectionsURL = `${DAM_API_URL}/apidam/getsharedcollection`;
export const revokeSharedCollectionURL = `${DAM_API_URL}/apidam/revokesharecollection`;
export const editCollectionAssetsURL = `${DAM_API_URL}/apidam/editcollectionassets`;
export const listOfUsersURL = `${DAM_API_URL}/clients/listofusers`;
export const getAllJobsURL = `${DAM_API_URL}/apidam/getalljobs`;
export const folderdata = `${DAM_API_URL}/apidam/folder/getAll`;
export const folderdata_v2 = `${DAM_API_URL}/apidam/dam-assets?forWhat=folder&`;
export const getSingleFolder = `${DAM_API_URL}/apidam/folder/getAssets/`;
export const Addfolder = `${DAM_API_URL}/apidam/folder/create`;
export const Editfolder = `${DAM_API_URL}/apidam/folder/rename`;
export const Deletefolder = `${DAM_API_URL}/apidam/folder/delete/`;
export const ListofDeactivatedAssetsURL = `${DAM_API_URL}/apidam/getdraftassets`;
export const Searchfolderkeyword = `${DAM_API_URL}/apidam/folder/search?searchKeyword=`;
export const SearchTagkeyword = `${DAM_API_URL}/apidam/tag-list?searchText=`;
export const GetAllUpload = `${DAM_API_URL}/apidam/folder/getAllUpload`;
export const GetAssignPermissionBasedonAssetId = `${DAM_API_URL}/apidam/share-asset-info`;
export const AddCollection = `${DAM_API_URL}/apidam/createcollection`;
export const DeleteCollection = `${DAM_API_URL}/apidam/deletecollection/`;
export const GetShareUrl = `${DAM_API_URL}/apidam/getUrl/`;
export const PassShareUrl = `${DAM_API_URL}/apidam/createUrl`;
export const downloadsinglefile = `${DAM_API_URL}/apidam/downloadSelectedFile`;
export const addcategory = `${DAM_API_URL}/apidam/brand-asset/category`;
export const updateaddcategory = `${DAM_API_URL}/apidam/brand-asset/category`;
export const getcategory = `${DAM_API_URL}/apidam/brand-asset/category`;
export const addcategory_sub = `${DAM_API_URL}/apidam/subcategory`;
export const addcategoryColor = `${DAM_API_URL}/apidam/color`;
export const updatesubcategory_sub = `${DAM_API_URL}/apidam/subcategory`;
export const uploadassetes_dam = `${DAM_API_URL}/apidam/upload-brand-asset`;
export const getpredefined_dam = `${DAM_API_URL}/apidam/brand-asset/brand-cat-types`;
export const downoadbrandasset_dam = `${DAM_API_URL}/apidam/download-brand-asset`;
export const Changeassetstatus = `${DAM_API_URL}/apidam/changeassetstatus`;
export const MoveForApprovalAPI = `${DAM_API_URL}/apidam/sent-for-approval`;
export const Sharedata = `${DAM_API_URL}/apidam/share-info`;
export const getactivities = `${DAM_API_URL}/apidam/get-activities`;
export const sharedemail = `${DAM_API_URL}/apidam/email-shared?shareUniqueId=`;
export const Downloadactivity = `${DAM_API_URL}/apidam/activity-download?shareUniqueId=`;
export const GET_ALL_COUNTRIES = `${API_URI}/api/centeral/clientscountries`;
export const GET_ALL_DEPARTMENTS = `${API_URI}/clients/listofdepartment`;
export const ASSIGN_FOLDER_COLLECTION = `${DAM_API_URL}/apidam/assign-assets`;
export const GET_ASSET_TYPE_FILTER_DATA = `${DAM_API_URL}/apidam/file-type-extension`;
export const UPLOAD_ASSET_IN_BRAND_ASSET = `${DAM_API_URL}/apidam/upload-image`;
export const ADD_BRAND_ASSET_BRAND_LOGO = `${DAM_API_URL}/apidam/cat-brand-data`;
export const GET_DEACTIVATE_ASSET = `${DAM_API_URL}/apidam/deactivate-asset`;
export const GET_APPROVE_ASSETS =  `${DAM_API_URL}/apidam/approve-asset`;
export const GET_EXPIRE_SECTION_DATA = `${DAM_API_URL}/apidam/expired-asset`;
export const GET_FUTURE_EXPIRE_SECTION_DATA = `${DAM_API_URL}/apidam/future-expired-asset`;
export const GET_INSIDE_FOLDER_DATA = `${DAM_API_URL}/apidam/search`;
export const ACTIVATE_MULTIPLE_ASSET = `${DAM_API_URL}/apidam/activate-asset`;
export const UPDATE_THUMBNAIL = `${DAM_API_URL}/apidam/update-thumbnail`;
export const DELETE_PERTICULAR_THUMBNAIL = `${DAM_API_URL}/apidam/delete-s3url`;
export const DOWNLOAD_SELECTED_FOLDER = `${DAM_API_URL}/apidam/download-folder-by-id`;
export const ROUTED_INNNER_FOLDER_DATA = `${DAM_API_URL}/apidam/get-folder-info`;
export const GET_USER_RELATED_TO_DEPARTMENT = `${API_URI}/api/clients/users/getuserslistbydepartment`;
export const GET_CATEGORY_SUB_CATEGORY_RELATED_TO_SKU = `${API_URI}/api/clients/products/getskucategoryandsubcatgeory`;
export const DELETE_MULTIPLE_ASSET = `${DAM_API_URL}/apidam/delete-asset`;
export const DOWNLAOD_MULTIPLE_ASSET = `${DAM_API_URL}/apidam/download-asset`;
export const DOWNLOAD_READY_ASSETS_API=`${DAM_API_URL}/apidam/download`

export const ASSET_DELETION_SECTION = `${DAM_API_URL}/apidam/delete-activity`;
export const MOVE_TO_ASSET_DATA = `${DAM_API_URL}/apidam/move-asset`;
export const UPDATE_SETTING_ASSETS_UPLOAD = `${DAM_API_URL}/apidam/setting-information`;
export const CONVERT_IMAGE_TO_BINARY = `${DAM_API_URL}/apidam/convert-image-to-byte`;
export const GET_META_DATA_RELATED_TO_ASSET = `${DAM_API_URL}/apidam/asset-meta-data`;
export const UPLOAD_FILE_DATA = `${DAM_API_URL}/apidam/search-image`;
export const ASSETS_LOG_DETAILS = `${DAM_API_URL}/apidam/asset-log`;
export const ASSET_LOG_VIEW_DETAILS = `${DAM_API_URL}/apidam/asset-log-view`
export const UPDATE_FOLDER_COLOR = `${DAM_API_URL}/apidam/folder/update-color`;
export const GET_FOLDER_COLORS = `${DAM_API_URL}/apidam/folder/folder-color`;
export const GET_VERSION_HISTORY_DATA = `${DAM_API_URL}/apidam/get-version-history`;
export const CREATE_VERSION_HISTORY_DATA = `${DAM_API_URL}/apidam/create-version`;
export const RESTORE_VERSION_HISTORY = `${DAM_API_URL}/apidam/restore-version`;
export const DELETE_ASSETS_FOR_EVER = `${DAM_API_URL}/apidam/delete-asset-forever`;
export const GENERATE_STREAMING_URL = `${DAM_API_URL}/apidam/create-hls`;


export const UPDATE_BANDWIDTH=`${DAM_API_URL}/apidam/update-bandwidth`




export const GET_BRAND_PROJECTS = `${DAM_API_URL}/apidam/brand-asset/brand-project`;
export const CREATE_BRAND_PROJECT = `${DAM_API_URL}/apidam/brand-asset/brand-project`;
export const UPLOAD_BRAND_ASSET = `${DAM_API_URL}/apidam/brand-asset/brand-asset-upload`;
export const GET_BRAND_CATEGORY_ASSETS = `${DAM_API_URL}/apidam/brand-asset/category-asset`;
export const DOWNLOAD_BRAND_ASSETS = `${DAM_API_URL}/apidam/brand-asset/download-brand-asset`
export const UPDATE_BRAND_ASSESTS_PERMISSION=`${DAM_API_URL}/apidam/brand-asset/update-brand-project-permission`


